<template>
  <div class="md-layout" >
    <div id="objectHeaderContentHidden" style="display: none;">
      <div><md-icon class="icon-color">{{list.pageIcon}}</md-icon></div>
      <div>
        <h1 class="md-title icon-color">{{ $route.name }}</h1>
      </div>
    </div>

    <div class="md-layout-item" >
      <ElasticList :list="list" ref="salesRepsRef"></ElasticList>
    </div>
  </div>
</template>

<script>
  import ElasticList from "@/components/DynamicForm/ElasticList";
  import _ from 'lodash';

  export default {
    components: {
      ElasticList
    },
    data() {
      return {
        list: {
          hideListHeader: true,
          editPath: "salesreps",
          pageTitle: "Salesreps",
          pageIcon: "assignment_ind",
          listQueryId: "searchSalesReps",
          linkRows: true,
          deleteQueryId: "deleteSalesRep",
          deleteMessageNameFields: ['given_name','family_name'],
          deleteRelatedRecord: {
            record: [ 
                { deleteSyncQueryId: "deleteCaseSalesRep", relatedModelItem: 'cases' } 
              ]
          },
          columns: {
            given_name: { label: "First Name", sortable: true },
            family_name: { label: "Last Name", sortable: true },
            email: { label: "Email", sortable: true },
            createdAt: { label: "Created", sortable: true },
          },
          perPageOptions: [5, 10, 20, 25, 50],
          defaults: {
            sort: 'createdAt',
            sortDir: 'desc',
            perPage: 10,
          },
          fuseSearch: null,
          ignoreSortColumns: ['createdAt'],
          formatResponse: data => {
            const items = this.$reduce(data, 'searchSalesReps.items');
            if (items && items.length) {
              const salesRepsRef = this.$refs.salesRepsRef;
              const sortedItmes = _.sortBy(items, salesRepsRef.currentSort);
              if ('desc' == salesRepsRef.currentSortDir) {
                return sortedItmes.reverse();
              } else {
                return sortedItmes;
              }
            }
            return [];
          },
        },
      };
    },
  };
</script>

<style></style>
